export default "__VITE_ASSET__gk0NAZ25__"